<div class="p-3 border rounded-3 bg-light shadow">
  <div class="d-flex align-items-center">
    <i class="pe-3 fa-solid fa-2x text-muted"
       [ngClass]="adDetails.adType === AdType.DirectSale ? 'fa-shopping-cart' : 'fa-gavel'">
    </i>
    <div class="ps-3 border-start">
      <h4 class="m-0 text-primary-emphasis">
        {{ adDetails.price.toFixed(2) }} лв.
      </h4>
      <div class="d-flex align-items-center gap-1">
        <small class="text-muted">
          {{ adDetails.adType === AdType.DirectSale ? 'Обява с фиксирана цена' : 'Обява с наддаване (аукцион)' }}
        </small>
        <button
          type="button"
          (click)="showAdTypeInfo()"
          aria-label="Научете повече"
          class="p-0 btn btn-link btn-sm text-primary-emphasis">
          <i class="fa-regular fa-circle-question" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>
  @if (adDetails.adType === AdType.DirectSale) {
    @if (adDetails.adStatus === AdStatus.Active && !adDetails.isUserOwner) {
      <button
        class="mt-3 w-100 btn btn-nz-primary"
        (click)="onOpenPurchaseConfirmModal()"
        [disabled]="adDetails.adStatus != AdStatus.Active || adDetails.isUserBlocked">
        <i class="me-2 fa-solid fa-shopping-cart"></i>
        Купи сега
      </button>
      @if (adDetails.isOfferSubmissionAllowed && !adDetails.buyerOffer) {
        <button
          class="mt-3 w-100 btn btn-nz-primary"
          (click)="onOpenAdOfferModal()"
          [disabled]="adDetails.adStatus != AdStatus.Active || adDetails.isUserBlocked">
          <i class="me-2 fa-solid fa-repeat"></i>
          <span>Предложи цена</span>
        </button>
      }
    }
  } @else {
    @if (adDetails.isReservedPriceNotReached) {
      <div class="my-3 ">
        <i class="text-warning fa-solid fa-triangle-exclamation"></i>
        Запазената цена не е достигната.
      </div>
    }
    <div class="mt-3">
      Минимална стъпка {{ adDetails.bidIncrement.toFixed(2) }} лв.
    </div>
    @if (adDetails.adStatus === AdStatus.Active && !adDetails.isUserOwner) {
      <div class="mb-3 input-group">
        <button type="button"
                aria-label="Намаляване"
                class="btn btn-outline-secondary border"
                (click)="decreaseBidAmount()"
                [disabled]="bidAmount === minBidAmount || adDetails.isUserBlocked">
          <i class="fa-solid fa-minus"></i>
        </button>
        <input id="bid"
               type="number"
               [(ngModel)]="bidAmount"
               class="form-control text-center"
               aria-label="Наддаване за артикул">
        <button type="button"
                aria-label="Увеличаване"
                class="btn btn-outline-secondary border"
                [disabled]="adDetails.isUserBlocked"
                (click)="increaseBidAmount()">
          <i class="fa-solid fa-plus"></i>
        </button>
      </div>
      <div class="my-3">
        <button type="button"
                [disabled]="adDetails.isUserBlocked"
                (click)="onOpenBidConfirmModal()"
                class="w-100 btn btn-nz-primary">
          <i class="me-2 fa-solid fa-gavel"></i>
          Наддаване
        </button>
      </div>
      @if (!!adDetails.buyNowPrice) {
        <div class="my-3">
          <button type="button"
                  class="w-100 btn btn-nz-primary"
                  [disabled]="adDetails.isUserBlocked"
                  (click)="onOpenPurchaseConfirmModal()">
            <i class="me-2 fa-solid fa-shopping-cart"></i>
            Купи сега за {{ adDetails.buyNowPrice.toFixed(2) }} лв.
          </button>
        </div>
      }
    }
    <hr class="my-3">
    <button
      [disabled]="!adDetails.bidCount"
      (click)="onOpenBidHistoryModal()"
      class="p-0 btn btn-link text-decoration-none">
      Наддавания: {{ adDetails.bidCount }}
    </button>
  }
</div>
